const collectionItemShowDescriptionByMobileSwipe = () => {
  const id = setInterval(() => {
    const blocks = document.querySelectorAll('.grid__item .grid-view-item__image-with-text, .search-item .grid-view-item__image-with-text');
    if (!blocks?.length) return;
    clearInterval(id);
    blocks.forEach(block => {
      let touchstartX = 0
      let touchendX = 0

      function getDirection() {
        if (touchendX < touchstartX) return -1;
        if (touchendX > touchstartX) return 1;
        return 0;
      }

      block.addEventListener('touchstart', e => {
        touchstartX = e.changedTouches[0].screenX
      })

      block.addEventListener('touchend', e => {
        touchendX = e.changedTouches[0].screenX
        if (getDirection() < 0) {
          block.classList.add('grid-view-item__image-with-text--active');
        }
        if (getDirection() > 0) {
          block.classList.remove('grid-view-item__image-with-text--active');
        }
      })
    })
  }, 100);
}

const paralax = () => {
  document.addEventListener('scroll', () => {
    const wHeight = window.innerHeight - 100;
    const scrollTop = window.scrollY;
    const els = document.querySelectorAll('.paralax-scroll');
    if(els){
      els.forEach(el => {
        el.style.transform = 'translate3d(0px, '+ (scrollTop / 2)  +'px , 0px)';
      })
    }
  })
}

const hideBagReviews = () => {
  const blocks = document.querySelectorAll('.collection-main-body .grid-view-item__meta .jdgm-prev-badge[data-average-rating]');
  if(blocks){
    blocks.forEach(block => {
      console.log(block.dataset.averageRating)
      if(block.dataset.averageRating < 3.5){
        block.style.visibility = 'hidden';
      }
    })
  }
}
const dinamicCollectionItemTitleFontSize = () => {
  if (window.innerWidth < 769) {
    const titles = document.querySelectorAll('.grid-view-item__title a');
    if(titles){
      titles.forEach(title => {
        if(title.innerHTML.length > 110) title.style.fontSize = '14px'
      })
    }
  }
}

const collectionAccordion = () => {
  const btn = document.querySelector('[data-collection-description-btn]');
  if(btn){
    btn.addEventListener('click', () => {
      btn.innerHTML = btn.innerHTML === 'Read more' ? 'Read less' : 'Read more';
      btn.parentNode.classList.toggle('collection-description--active');
    })
  }
}

const showCollectionDescriptionReadMoreBtn = () => {
  const btn = document.querySelector(['[data-collection-description-btn]']);
  if(btn){
    const contentBlockHideItem = document.querySelector('.collection-description__text p:not(:first-of-type), .collection-description__text p:not(:first-of-type) + *');
    if(!contentBlockHideItem){
      btn.style.display = 'none';
    }
  }
}

const mobileCollectionScroll = () => {
  const arrow = document.querySelector('[data-collection-header-arrow]');
  if(arrow){
    arrow.addEventListener('click', () => {
      const header = document.querySelector('.collection__header');
      window.scrollTo({ top: header.offsetHeight + 70, behavior: 'smooth'})
    })
  }
}

(function(){
  collectionItemShowDescriptionByMobileSwipe();
  paralax();
  hideBagReviews();
  collectionAccordion();
  showCollectionDescriptionReadMoreBtn();
  mobileCollectionScroll();
  document.addEventListener('scroll', dinamicCollectionItemTitleFontSize);
  document.addEventListener('resize', dinamicCollectionItemTitleFontSize);
})();

